var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 135,
    viewBox: "0 0 152 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 63.628,
    r: 56.5581,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6744,
    cy: 24.7442,
    r: 5.30233,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0231,
    cy: 106.046,
    r: 7.06977,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.395,
    cy: 38.8837,
    r: 7.06977,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.674,
    cy: 15.0231,
    r: 4.4186,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_788_45979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0001 39.4575L80.9631 37.3787L76.0008 39.4927V98.6794L121.731 79.5164V20.3033L121.954 20.2099L121.731 20.1111V20.0117L121.616 20.0604L76.361 0L30.0466 19.7287L30.2659 19.8229L30.0466 78.7955L76.0001 98.6442L76.0001 39.4575Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0001 39.4569V98.6436L30.0466 78.7949L30.2659 19.8223L76.0001 39.4569Z",
    fill: "url(#paint0_linear_788_45979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0007 39.4923V98.679L121.731 79.516V20.0112L76.0007 39.4923Z",
    fill: "url(#paint1_linear_788_45979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0001 39.4575L121.954 20.2099L76.361 0L30.0466 19.7287L76.0001 39.4575Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 12.3502L93.1474 32.2758L93.5632 46.7961L106.371 41.5112L105.984 26.8991L58.8516 7.45898L47.3691 12.3502Z",
    fill: "#EAECF0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_788_45979)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 64.3721,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 77.8721C70.2016 77.8721 65.5 82.5736 65.5 88.3721C65.5 94.1705 70.2016 98.8721 76 98.8721C81.7984 98.8721 86.5 94.1705 86.5 88.3721C86.5 82.5736 81.7984 77.8721 76 77.8721ZM76 97.0908C71.1859 97.0908 67.2812 93.1861 67.2812 88.3721C67.2812 83.558 71.1859 79.6533 76 79.6533C80.8141 79.6533 84.7188 83.558 84.7188 88.3721C84.7188 93.1861 80.8141 97.0908 76 97.0908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8746 92.4971C74.8746 92.7954 74.9932 93.0816 75.2041 93.2926C75.4151 93.5035 75.7013 93.6221 75.9996 93.6221C76.298 93.6221 76.5842 93.5035 76.7951 93.2926C77.0061 93.0816 77.1246 92.7954 77.1246 92.4971C77.1246 92.1987 77.0061 91.9126 76.7951 91.7016C76.5842 91.4906 76.298 91.3721 75.9996 91.3721C75.7013 91.3721 75.4151 91.4906 75.2041 91.7016C74.9932 91.9126 74.8746 92.1987 74.8746 92.4971ZM75.4371 89.8721H76.5621C76.6653 89.8721 76.7496 89.7877 76.7496 89.6846V83.3096C76.7496 83.2064 76.6653 83.1221 76.5621 83.1221H75.4371C75.334 83.1221 75.2496 83.2064 75.2496 83.3096V89.6846C75.2496 89.7877 75.334 89.8721 75.4371 89.8721Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_788_45979",
    x: 12.3722,
    y: 0,
    width: 127.256,
    height: 134.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.53488,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_788_45979"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.06977
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.53488
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_788_45979"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.53488,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_788_45979"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.6744
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6047
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_788_45979",
    result: "effect2_dropShadow_788_45979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_788_45979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_788_45979",
    x: 45.1429,
    y: 57.5149,
    width: 61.7143,
    height: 61.7143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_788_45979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_788_45979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_788_45979",
    x1: 30.0466,
    y1: 79.0924,
    x2: 48.195,
    y2: 29.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_788_45979",
    x1: 76.0001,
    y1: 40.6507,
    x2: 127.817,
    y2: 50.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F4F7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.276f6cc9f3e240ce61bbe5ee8dfb1ab0.svg";
export { ForwardRef as ReactComponent };